import { SET_ERROR, RESET } from "../types/errors";

const initialState = {
  errorMessage: null,
};

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

export default errorReducer;
